import { render, staticRenderFns } from "./Mvp.vue?vue&type=template&id=36882d0d"
import script from "./Mvp.vue?vue&type=script&lang=js"
export * from "./Mvp.vue?vue&type=script&lang=js"
import style0 from "./Mvp.vue?vue&type=style&index=0&id=36882d0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports